const CHANNEL = "dom-belloni-painel-refresh";

export function broadcastPainelRefresh(): void {
  if (typeof BroadcastChannel !== "undefined") {
    try {
      const bc = new BroadcastChannel(CHANNEL);
      bc.postMessage(1);
      bc.close();
      return;
    } catch {}
  }
  window.dispatchEvent(new CustomEvent("dom-belloni-painel-refresh"));
}

export function subscribePainelRefresh(handler: () => void): () => void {
  if (typeof BroadcastChannel !== "undefined") {
    try {
      const bc = new BroadcastChannel(CHANNEL);
      bc.onmessage = () => handler();
      return () => bc.close();
    } catch {}
  }
  const fn = () => handler();
  window.addEventListener("dom-belloni-painel-refresh", fn);
  return () => window.removeEventListener("dom-belloni-painel-refresh", fn);
}
